import DrugsAZ from "../routes/DrugsAZ";
import DiseasesAndConditions from "../routes/DiseasesAndConditions";
import ChemoRegimensList from "./ChemoRegimensList";
import ChemoRegimensFilter from "./ChemoRegimensFilter";
import AccordionTemplate from "./AccordionTemplate";
import TileTemplate from "./TileTemplate";
import TocTemplate from "./TocTemplate";
import ListTemplate from "./ListTemplate";

export const templateEnum = {
  DrugsAZ,
  DiseasesAndConditions,
  ChemoRegimensList,
  ChemoRegimensFilter,
  toc: TocTemplate,
  accordion: AccordionTemplate,
  tile: TileTemplate,
  list: ListTemplate,
};
